import * as React from 'react';
import * as styles from './styles.css';
import { Button } from '@cian/ui-kit/button';

export interface ISubmitButtonProps {
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  children?: React.ReactText | React.ReactText[];

  onClick?(): void;
}

export const SubmitButton: React.FC<React.PropsWithChildren<ISubmitButtonProps>> = ({
  disabled,
  onClick,
  fullWidth,
  loading,
  children,
}) => {
  return (
    <div className={styles['submit']}>
      <Button
        type="submit"
        size={'M'}
        disabled={disabled}
        onClick={onClick}
        data-testid="next"
        fullWidth={fullWidth}
        loading={loading}
      >
        {children}
      </Button>
    </div>
  );
};

SubmitButton.displayName = 'SubmitButton';
